var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSoundModuleLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 12V14H12.667V12H11.3337V10.6667H15.3337V12H14.0003ZM3.33366 12V14H2.00033V12H0.666992V10.6667H4.66699V12H3.33366ZM7.33366 4V2H8.66699V4H10.0003V5.33333H6.00033V4H7.33366ZM7.33366 6.66667H8.66699V14H7.33366V6.66667ZM2.00033 9.33333V2H3.33366V9.33333H2.00033ZM12.667 9.33333V2H14.0003V9.33333H12.667Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSoundModuleLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sound-module-line.c9dbfbdb.svg";
export { ForwardRef as ReactComponent };